import { ReactNode } from "react"

interface Props {
  children: ReactNode
}
export const Card = ({ children }: Props) => (
  <div className="flex flex-col gap-4 rounded-lg border border-gray-200 p-6">{children}</div>
)
